import { Buffer } from 'buffer';

import { HttpError } from 'src/http/errors/http-error';
import { httpResponseHandler } from 'src/http/http-response-handler';
import { Either } from 'src/utils/either';

import { HttpTypes } from '../../http';

export class LoginRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async login(keepConnected: boolean, email: string, password: string): Promise<Either<HttpError, any | undefined>> {
    const base64 = Buffer.from(`${email}:${password}`, 'utf-8').toString('base64');
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `admin-auth/login`,
      body: { keepConnected },
      headers: { authorization: `Bearer ${base64}` },
    };

    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async verifyAccount(body: { type: 'email' | 'sms' | 'whatsapp'; data: string }): Promise<Either<HttpError, any | undefined>> {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `admin/verify-account`,
      body: {
        type: body.type,
        data: body.data,
      },
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async verifyCode(body: { data: string; code: number }): Promise<Either<HttpError, any | undefined>> {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `admin/verify-code`,
      body,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async newPassword(body: { token: string; password: string }): Promise<Either<HttpError, any | undefined>> {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: `admin/new-password`,
      body,
      headers: {},
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async getUserData(id?: string): Promise<Either<HttpError, any | undefined>> {
    const request: HttpTypes.HttpRequest = {
      url: `admin/${id}`,
      method: 'get',
    };

    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }
}
